module.exports = require('./react-bricks.cjs.production.min.js');